<template>
    <div>
        <limitless-page-header
            title="Leverantörer"
            sub-title="Produktreklamation"
            :title-id="(complaint && complaint.id > 0 ? complaint.id : (not_found ? '???' : 'Ny'))"
        >
            <template #header-elements>
                <limitless-page-header-button v-if="complaint && complaint.supplier_id" :url="'/suppliers/' + complaint.supplier_id" icon="icon-truck">
                    Leverantör
                </limitless-page-header-button>
                <limitless-page-header-button v-if="complaint && complaint.prod_id" :url="'/products/' + complaint.prod_id" icon="icon-gift">
                    Produkt
                </limitless-page-header-button>
                <limitless-page-header-button v-if="complaint && complaint.return_order_id" :url="'/returnorders/' + complaint.return_order_id" icon="icon-clipboard3">
                    Gå till order
                </limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div v-if="!initialized && busy_loading" class="content">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else-if="!not_found && complaint" class="content" style="padding-bottom: 6rem;">
            <div class="mb-3" v-if="complaint.id > 0">
                <limitless-button
                    btn-class="btn-secondary mr-2"
                    @click="showModalSend"
                    icon="icon-paperplane"
                >Skicka</limitless-button>
                <limitless-button
                    ref="btncompletecomplaint"
                    :btn-class="(complaint.completed_at ? 'btn-warning' : 'btn-success' ) + ' mr-2'"
                    :icon="(complaint.completed_at ? 'icon-reload-alt' : 'icon-checkmark4' )"
                    @click="setCompleted(!!(complaint.completed_at))"
                >
                    {{ (complaint.completed_at ? 'Återöppna' : 'Avsluta' ) }}
                </limitless-button>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <form @submit.prevent="saveComplaint">
                        <ValidationObserver ref="complaintform">
                            <div class="card">
                                <div class="card-header header-elements-inline bg-light">
                                    <h6 class="card-title">
                                        <i class="icon-pencil mr-2"></i>
                                        {{ (complaint.id > 0 ? 'Redigera reklamation' : 'Skapa reklamation') }}
                                    </h6>
                                    <div class="header-elements">
                                        <div v-if="complaint.completed_at" class="badge badge-secondary">Avslutad</div>
                                        <div v-else-if="complaint.sent_at" class="badge badge-warning">Skickad</div>
                                        <div v-else class="badge badge-yellow">Ny</div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group" v-if="complaint.id > 0">
                                                <div>Skapad: {{ formatDateTime(complaint.created_at) }}{{ (complaint.created_by_user ?  ' / ' + complaint.created_by_user.FullName : '') }}</div>
                                                <div>Ändrad: {{ formatDateTime(complaint.updated_at) }}{{ (complaint.updated_by_user ?  ' / ' + complaint.updated_by_user.FullName : '') }}</div>
                                                <div v-if="complaint.sent_at">Skickad: {{ formatDateTime(complaint.sent_at) }}{{ (complaint.sent_by_user ?  ' / ' + complaint.sent_by_user.FullName : '') }}</div>
                                                <div v-else>EJ Skickad</div>
                                                <div v-if="complaint.completed_at">Avslutad: {{ formatDateTime(complaint.completed_at) }}{{ (complaint.completed_by_user ?  ' / ' + complaint.completed_by_user.FullName : '') }}</div>
                                                <div v-else>EJ Avslutad</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <ValidationProvider
                                                vid="prod_id"
                                                name="Produkt"
                                                rules="required"
                                            >
                                                <div class="form-group">
                                                    <label>Product<span class="text-danger">*</span></label>
                                                    <product-filter
                                                        ref="prodfilter"
                                                        v-model="complaint.prod_id"
                                                        :reduce="(opt) => opt.ProdID"
                                                        placeholder="Välj produkt..."
                                                        @option:selected="productSelected"
                                                        @close="$refs.prodfilter.$el.closest('.card').focus();"
                                                    ></product-filter>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-6">
                                            <ValidationProvider
                                                vid="supplier_id"
                                                name="Leverantör"
                                                rules="required"
                                            >
                                                <div class="form-group">
                                                    <label>Leverantör<span class="text-danger">*</span></label>
                                                    <supplier-filter
                                                        v-model="complaint.supplier_id"
                                                        :reduce="(opt) => opt.id"
                                                        placeholder="Välj Leverantör..."
                                                    ></supplier-filter>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-6">
                                            <input-with-validation
                                                vid="quantity"
                                                type="number"
                                                label="Antal"
                                                v-model="complaint.quantity"
                                                rules="required"
                                            ></input-with-validation>
                                        </div>
                                    </div>
                                    <div class="row">
<!--                                        <div class="col-lg-4">-->
<!--                                            <div class="custom-control custom-checkbox mb-3">-->
<!--                                                <input type="checkbox" class="custom-control-input" id="chk-freightdamaged" v-model="complaint.freight_damaged" :true-value="1" :false-value="0">-->
<!--                                                <label class="custom-control-label" for="chk-freightdamaged">Fraktskada</label>-->
<!--                                            </div>-->
<!--                                        </div>-->
                                        <div class="col-lg-4">
                                            <div class="custom-control custom-checkbox mb-3">
                                                <input type="checkbox" class="custom-control-input" id="chk-fixedsupplier" v-model="complaint.fixed_supplier">
                                                <label class="custom-control-label" for="chk-fixedsupplier">Åtgärdad mot Leverantör</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="custom-control custom-checkbox mb-3">
                                                <input type="checkbox" class="custom-control-input" id="chk-fixedcustomer" v-model="complaint.fixed_customer">
                                                <label class="custom-control-label" for="chk-fixedcustomer">Åtgärdad mot kund</label>
                                            </div>
                                        </div>
                                    </div>
                                    <textarea-with-validation
                                        vid="description"
                                        rules=""
                                        label="Beskrivning av fel/skada"
                                        :min-height="100"
                                        v-model="complaint.description"
                                    ></textarea-with-validation>
                                    <textarea-with-validation
                                        vid="internal_comment"
                                        rules=""
                                        label="Intern kommentarer"
                                        :min-height="100"
                                        v-model="complaint.internal_comment"
                                    ></textarea-with-validation>
                                    <div class="text-right">
                                        <limitless-button @click="saveComplaint" ref="btnsavecomplaint" icon="icon-floppy-disk">SPARA</limitless-button>
                                    </div>
                                </div>
                            </div>
                        </ValidationObserver>
                    </form>
                </div>
                <div class="col-lg-4" v-if="id > 0 && complaint.id > 0">
                    <div
                        v-if="complaint.returnorder"
                        class="card"
                    >
                        <div class="card-header header-elements-inline bg-light">
                            <h6 class="card-title">Kopplad till kundreklamation</h6>
                            <div class="header-elements">
                                <div class="badge" :class="['badge-' + complaint.returnorder.status.Class]">{{ complaint.returnorder.status.Status }}</div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div>Kund: <router-link :to="{ name: 'returnorder.edit', params: { id: complaint.returnorder.ReturnOrderID } }">{{ complaint.returnorder.Name }}</router-link></div>
                            <div>Kortnummer: <router-link :to="{ name: 'returnorder.edit', params: { id: complaint.returnorder.ReturnOrderID } }">{{ complaint.returnorder.CardNo }}</router-link></div>
                        </div>
                    </div>
                    <div class="card" style="max-height: 743px;">
                        <div class="card-header header-elements-inline bg-light">
                            <h6 class="card-title"><i class="icon-list mr-2"></i>Logg</h6>
                            <div class="header-elements">
                                <b-button variant="light" @click="show_full_log = !show_full_log">{{ (show_full_log ? 'Dölj' : 'Visa') }} automatiska loggar</b-button>
                            </div>
                        </div>
                        <div class="overflow-auto flex-grow-1">
                            <div
                                v-for="(log, l_index) in filteredLogs"
                                :key="'l-' + l_index"
                                class="border-bottom p-2"
                            >
                                <div>
                                    <span class="font-weight-semibold">{{ log.user.FullName }}</span>
                                    <span class="text-muted">
                                        <span class="mx-1">&bull;</span>
                                        {{ formatDateTime(log.created_at) }}
                                    </span>
                                </div>
                                <div>
                                    {{ log.log }}
                                </div>
                            </div>
                        </div>
                        <div class="card-body flex-shrink-0">
                            <ValidationObserver ref="logform">
                                <textarea-with-validation
                                    vid="comment"
                                    rules="required"
                                    label="Kommentarer"
                                    v-model="comment"
                                    :disabled="busy_saving_log"
                                    placeholder="Skriv i loggen..."
                                ></textarea-with-validation>
                            </ValidationObserver>
                            <div class="text-right mt-2">
                                <limitless-button ref="btnsavecomment" @click="saveComment" icon="icon-pencil3" :busy="busy_saving_log">SKRIV</limitless-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" v-if="id > 0 && complaint.id > 0">
                <div class="card-header header-elements-inline bg-light">
                    <b-card-title><i class="icon-images2 mr-2"></i>Bilder / Video / Filer</b-card-title>
                    <div class="header-elements">
                        <limitless-button @click="showUploadModal" btn-class="btn-light" icon="icon-cloud-upload">Ladda upp</limitless-button>
                    </div>
                </div>
                <div class="card-body">
                    <div v-if="images.length > 0"
                         class="file-grid"
                    >
                        <div v-for="(image, i_index) in images"
                             :key="'i-' + i_index"
                        >
                            <div class="card mb-0" >
                                <div class="card-body p-1">
                                    <div class="image-wrapper"
                                         :style="{ 'background-image': 'url(' + image.url_preview + ')' }"
                                         @click="showFullImage(image.url_show ? image.url_show : image.url_download)" style="cursor: pointer;"
                                    ></div>
                                </div>
                                <div class="p-1" style="overflow: hidden; max-width: 100%; text-overflow: ellipsis; word-break: break-word; text-align: center;">
                                    {{ image.filename }}
                                </div>
                                <div class="card-footer d-flex p-0">
                                    <div v-if="image.url_show" class="p-1 flex-grow-1">
                                        <b-button variant="light" block @click="showFullImage(image.url_show)">Visa större</b-button>
                                    </div>
                                    <div v-else class="p-1 flex-grow-1">
                                        <b-button variant="light" block @click="downloadImage(image.url_download)">Ladda ner</b-button>
                                    </div>
                                    <div class="p-1 flex-grow-1">
                                        <b-button variant="danger" block @click="deleteImage(image.filename)">Radera</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else><i>Inga bilder</i></div>
                </div>
            </div>

            <div class="card" v-if="id > 0 && complaint.id > 0">
                <div class="card-header header-elements-inline bg-light">
                    <h6 class="card-title"><i class="icon-file-pdf mr-2"></i>PDF</h6>
                    <div class="header-elements">
                        <limitless-button
                            btn-class="btn-light"
                            icon="icon-file-pdf"
                            @click="generatePdf"
                            :busy="busy_generating_pdf"
                            ref="btngeneratepdf"
                            saved-text="KLAR!"
                        >
                            Generera om
                        </limitless-button>
                    </div>
                </div>
                <div class="card-body">
                    <iframe v-if="complaint.pdf_url" :src="complaint.pdf_url" style="width: 100%; height: 850px;"></iframe>
                    <i v-else-if="busy_generating_pdf">Var god vänta...</i>
                    <i v-else>Ingen PDF...</i>
                </div>
            </div>

            <b-modal
                id="modal_upload_files"
                title="Ladda upp bilder / video / filer"
                key="modal_upload_files"
                ok-only
                scrollable
                ok-title="Stäng"
                ok-variant="light"
                size="xl"
                @hide="closeUploadModal"
            >
                <multiple-file-uploader
                    :url="'/vue/supplier_complaints/' + id + '/files/upload'"
                    :extensions="'jpg,jpeg,png,pdf,mp4,m4v,mov,doc,docx,xls,xlsx,txt'"
                    :accept="'image/png,image/jpeg,application/pdf,video/mp4,video/x-m4v,video/quicktime' +
                    'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
                    'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain'"
                    @busy="busy_uploading_files = $event"
                    multiple
                />
            </b-modal>

            <b-modal id="modal-send" title="Skicka" size="lg" @ok="sendComplaint">
                <ValidationObserver ref="sendcomplaintform">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Skickas från</label>
                        <div class="col-lg-10">
                            <input-with-validation
                                label="Från"
                                v-model="send.from"
                                :disabled="busy_sending"
                                rules="required"
                                hide-label
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Skickas till</label>
                        <div class="col-lg-10">
                            <input-with-validation
                                label="Till"
                                v-model="send.to"
                                :disabled="busy_sending"
                                rules="required"
                                hide-label
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Ärende</label>
                        <div class="col-lg-10">
                            <input-with-validation
                                label="Ärende"
                                v-model="send.subject"
                                :disabled="busy_sending"
                                rules="required"
                                hide-label
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Bifoga</label>
                        <div class="col-lg-10 pt-2">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="chk-attach-pdf" v-model="send.attach_pdf">
                                <label class="custom-control-label" for="chk-attach-pdf">PDF</label>
                            </div>
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="chk-attach-pictures" v-model="send.attach_pictures">
                                <label class="custom-control-label" for="chk-attach-pictures">Bilder</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Meddelande</label>
                        <div class="col-lg-10">
                            <textarea-with-validation
                                vid="message"
                                rules="required"
                                label="Meddelande"
                                :min-height="170"
                                v-model="send.message"
                                hide-label
                            ></textarea-with-validation>
                        </div>
                    </div>
                </ValidationObserver>
                <template #modal-footer="{ cancel, ok }">
                    <b-button variant="light" @click="cancel">Avbryt</b-button>
                    <limitless-button ref="btnsendpurchase" type="button" @click="ok" icon="icon-paperplane" :busy="busy_sending">Skicka</limitless-button>
                </template>
            </b-modal>

            <activity-notification :channel="'complaint-' + complaint.id"></activity-notification>
        </div>
        <div v-else-if="not_found" class="content">
            <i>Reklamationen hittades inte</i>
        </div>
        <div v-else class="content">
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import getError from '@services/ErrorHelper';
import { formatDateTime, genUUID } from '@services/Helpers';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import ActivityNotification from '@components/User/ActivityNotification.vue';
import ProductFilter from '@components/Filters/ProductFilter.vue';
import MultipleFileUploader from '@components/MultipleFileUploader.vue';
import { mapState } from 'pinia';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import TextareaWithValidation from '@components/Form/TextareaWithValidation.vue';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton.vue';
import SupplierFilter from '@components/Filters/CategoryFilter.vue';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    components: {
        SupplierFilter,
        LimitlessPageHeaderButton,
        TextareaWithValidation,
        InputWithValidation,
        ProductFilter,
        ActivityNotification,
        LimitlessPageHeader,
        LimitlessButton,
        MultipleFileUploader,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_saving: false,
        busy_deleting: false,
        busy_uploading_files: false,
        busy_generating_pdf: false,
        busy_loading_logs: false,
        busy_sending: false,
        busy_saving_log: false,
        show_full_log: false,
        comment: '',
        change_product: null,
        complaint: null,
        images: [],
        logs: [],
        send: {
            from: '',
            to: '',
            attach_pdf: true,
            attach_pictures: false,
            subject: '',
            message: '',
        },
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.images = [];
            this.logs = [];
            this.init();
        },
        change_product(product) {
            if (product) {
                if (product.ProdSupplierID > 0) {
                    if (this.complaint.supplier_id > 0) {
                        this.$swal({
                            text: 'Vill du även ändra leverantör?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Ja, ändra!',
                            cancelButtonText: 'Nej',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.complaint.supplier_id = parseInt(product.ProdSupplierID, 10);
                            }
                            this.$refs.prodfilter?.$el.closest('.card').focus();
                        });
                    } else {
                        this.complaint.supplier_id = parseInt(product.ProdSupplierID, 10);
                    }
                }
            }
            this.change_product = null;
        },
    },
    methods: {
        formatDateTime,
        genUUID,
        init() {
            this.getComplaint();
            if (this.id > 0) {
                this.getImages();
                this.getLogs();
            }
        },
        getComplaint() {
            this.busy_loading = true;
            apiClient.get('/vue/suppliers/complaints/' + this.id + '')
                .then((response) => {
                    this.complaint = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy_loading = false;
                    this.not_found = false;
                });
        },
        async setCompleted(reopen = false) {
            this.busy_saving = true;
            await apiClient.post('/vue/suppliers/complaints/batch/complete', { reopen, complaint_ids: [this.id] })
                .then(() => {
                    this.$refs.btncompletecomplaint.triggerSaved();
                    this.getComplaint();
                    this.getLogs();
                })
                .catch(() => {
                    this.$refs.btncompletecomplaint.triggerFailed();
                })
                .finally(() => {
                    this.busy_saving = false;
                });
        },
        async deleteImage(filename) {
            let doDelete = false;
            await this.$swal({
                text: 'Är du säker att du vill radera bilden?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera!',
                cancelButtonText: 'Avbryt',
            }).then((result) => {
                if (result.isConfirmed) {
                    doDelete = true;
                }
            });
            if (doDelete) {
                await apiClient.post('/vue/suppliers/complaints/' + this.id + '/images/delete', { images: [filename] })
                    .then(() => {
                        this.getImages();
                    });
            }
        },
        async saveComplaint() {
            const isValid = await this.$refs.complaintform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/suppliers/complaints/' + this.id, { ...this.complaint })
                    .then(async (response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.id, 10)) {
                            await this.$router.push({ name: 'complaints.edit', params: { id: response.data.id } });
                        }
                        this.complaint = response.data;
                        this.$refs.btnsavecomplaint.triggerSaved();
                        this.getLogs();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.complaintform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecomplaint.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            } else {
                this.$refs.btnsavecomplaint.triggerFailed();
            }
        },
        productSelected(product) {
            this.change_product = { ...product };
        },
        getLogs() {
            this.busy_loading_logs = true;
            apiClient.get('/vue/suppliers/complaints/' + this.id + '/logs')
                .then((response) => {
                    this.logs = response.data;
                })
                .finally(() => {
                    this.busy_loading_logs = false;
                });
        },
        getImages() {
            this.busy_loading_files = true;
            apiClient.get('/vue/supplier_complaints/' + this.id + '/files/list')
                .then((response) => {
                    this.images = response.data;
                })
                .finally(() => {
                    this.busy_loading_files = false;
                });
        },
        showUploadModal() {
            this.$root.$bvModal.show('modal_upload_files');
        },
        closeUploadModal(event) {
            if (this.busy_uploading_files) {
                event.preventDefault();
            } else {
                this.getImages();
            }
        },
        showFullImage(url) {
            window.open(url, '_blank');
        },
        downloadImage(url) {
            // Create a link and set the URL using `createObjectURL`
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.download = '';

            // It needs to be added to the DOM so it can be clicked
            document.body.appendChild(link);
            link.click();

            // To make this work on Firefox we need to wait
            // a little while before removing it.
            setTimeout(() => {
                URL.revokeObjectURL(link.href);
                link.parentNode.removeChild(link);
            }, 0);
        },
        async sendComplaint(e) {
            e.preventDefault();
            const isValid = await this.$refs.sendcomplaintform.validate();
            if (isValid) {
                this.busy_sending = true;
                await apiClient.post('/vue/suppliers/complaints/batch/send', { complaint_ids: [this.id], ...this.send })
                    .then(() => {
                        this.$bvModal.hide('modal-send');
                    }).catch(() => {
                        this.$refs.btnsendpurchase.triggerFailed();
                    }).finally(() => {
                        this.busy_sending = false;
                    });
            } else {
                this.$refs.btnsendpurchase.triggerFailed();
            }
        },
        async showModalSend() {
            let open = true;
            if (this.complaint.sent_at) {
                await this.$swal({
                    text: 'Reklamationen har redan skickats, vill du skicka igen?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja!',
                    cancelButtonText: 'Nej',
                }).then((result) => {
                    if (result.isConfirmed) {
                        open = true;
                    } else {
                        open = false;
                    }
                });
            }
            if (open) {
                this.send.from = this.user.email;
                this.send.subject = 'Product Complaint #' + this.complaint.id;
                this.send.message += 'Product Complaint #' + this.complaint.id + '\n';
                this.send.message += 'Product: #' + this.complaint.product.ProdSupplierSKU + ' ' + this.complaint.product.ProdName + ' (SKU ' + this.complaint.product.ProdID + ')\n\n';
                this.send.message += (this.complaint.description ?? '') + '\n\n';
                this.$bvModal.show('modal-send');
            }
        },
        async generatePdf() {
            this.busy_generating_pdf = true;
            this.complaint.pdf_url = '';
            await apiClient.post('/vue/suppliers/complaints/' + this.id + '/pdf/generate')
                .then((response) => {
                    if (response.data && response.data.url) {
                        this.complaint.pdf_url = response.data.url + '?hash=' + this.genUUID();
                    }
                }).catch(() => {
                    this.$refs.btngeneratepdf.triggerFailed();
                }).finally(() => {
                    this.busy_generating_pdf = false;
                });
        },
        async saveComment() {
            const isValid = await this.$refs.logform.validate();
            if (isValid) {
                this.busy_saving_log = true;
                await apiClient.post('/vue/suppliers/complaints/' + this.id + '/logs/0', { log: this.comment })
                    .then(() => {
                        this.comment = '';
                        this.$refs.btnsavecomment.triggerSaved();
                        this.$refs.logform.reset();
                    }).catch(() => {
                        this.$refs.btnsavecomment.triggerFailed();
                    }).finally(() => {
                        this.busy_saving_log = false;
                        this.getLogs();
                    });
            } else {
                this.$refs.btnsavecomment.triggerFailed();
            }
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        filteredLogs() {
            return this.logs.filter((log) => this.show_full_log || log.type === 2);
        },
        old_system_url() {
            return window.config.old_system_url;
        },
        old_system_url_nk() {
            return window.config.old_system_url.replace(':1462', ':1464').replace(':1492', ':1494');
        },
    },
};

</script>
<style scoped>
.image-wrapper {
    position: relative;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.image-wrapper div {
    background-color: #eeeeee;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-wrapper:after {
    content: '';
    width: 100%;
    padding-bottom: 75%;
    display: block;
}
.file-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    max-width: 100%;
    width: 100%;
}
@media only screen and (min-width: 1200px) {
    .file-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}
@media only screen and (min-width: 1440px) {
    .file-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}
@media only screen and (min-width: 1700px) {
    .file-grid {
        grid-template-columns: repeat(5, 1fr);
    }
}
</style>
